import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

class AppSearchAccommodations extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      typingTimeout: 0,
      loading: false,
      place: '',
      placeValid: true,
      selectedPlace: {},
      allPlaces: [],
      showSuggestions: false,
      showDatesSeperator: false,
      facilities: [],
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.facilities = [];

    const availableHotelFacilities = window.Ode['availableHotelFacilities'];
    if (!$.isEmptyObject(availableHotelFacilities)) {
      this.facilities = Object.keys(availableHotelFacilities).map(function(key) {
        return [key, availableHotelFacilities[key]];
      });
    }

    // Bind "this"
    this.onPlaceInputClickFocus = this.onPlaceInputClickFocus.bind(this);
    this.onPlaceInputBlur = this.onPlaceInputBlur.bind(this);
    this.onPlaceInputChange = this.onPlaceInputChange.bind(this);
    this.onPlaceInputKeyUp = this.onPlaceInputKeyUp.bind(this);
    this.loadPlaceSuggestions = this.loadPlaceSuggestions.bind(this);
    this.onPlaceItemClick = this.onPlaceItemClick.bind(this);
    this.handleClearPlaceInput = this.handleClearPlaceInput.bind(this);
    this.handleUrlParamsOnInput = this.handleUrlParamsOnInput.bind(this);
    this.handleDateRangePickerChanged = this.handleDateRangePickerChanged.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFacilitiesChanged = this.handleFacilitiesChanged.bind(this);
    this.redirectToSynxis = this.redirectToSynxis.bind(this);
    this.redirectToTelegraph = this.redirectToTelegraph.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    const {
      index,
      autoSubmit,
    } = this.props;

    if (autoSubmit == '1') {
      const location = helpers.getParameterByName('location');
      if (location != null && location.length) {
        this.setState({place: location});
      }

      const facilities = helpers.getParameterByName('facilities');
      if (facilities != null && facilities.length) {
        this.setState({facilities: facilities.split(',')});
      }
    }

    $(document).trigger(constants.EVENT_BOOKING_FORM_LOADED);

    const dateRangePicker = $('#accommodation-form-date-range-picker-' + index);
    if (dateRangePicker.length) {
      dateRangePicker.on('daterangepicker_changed', this.handleDateRangePickerChanged);
    }
  }

  redirectToTelegraph({
    hotelCode,
    hotelBrand,
    startDate,
    endDate,
    numGuests,
    dateFormat,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      DEFAULT_DATE_FORMAT,
      TELEGRAPH_CONSTANTS: {
        TELEGRAPH_URL,
        TELEGRAPH_HOTEL_ID,
        TELEGRAPH_DATE_DEFAULT_JS_FORMAT,
      },
    } = BookingWidget.constants;

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    if (!hotelKey) {
      return false;
    }

    const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
    const redirectToTelegraph = hotelData['redirectToTelegraph'];

    if (!redirectToTelegraph) {
      return false;
    }

    const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

    const arriveMoment = moment(startDate, bookingDateFormat);
    let arrival = startDate;

    if (arriveMoment.isValid()) {
      arrival = arriveMoment.format(TELEGRAPH_DATE_DEFAULT_JS_FORMAT);
    }

    const departMoment = moment(endDate, bookingDateFormat);
    let departure = endDate;

    if (departMoment.isValid()) {
      departure = departMoment.format(TELEGRAPH_DATE_DEFAULT_JS_FORMAT);
    }

    const rooms = numGuests.length;

    const params = {
      hotel: TELEGRAPH_HOTEL_ID,
      arrival,
      departure,
      rooms,
      codeType: 'promo',
      code: '',
    };

    numGuests.forEach((guest, idx) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      params[`adults[${idx + 1}]`] = isNaN(numAdults)? 0 : numAdults;
      params[`children[${idx + 1}]`] = isNaN(numChildren)? 0 : numChildren;
    });

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (!value) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    window.open(`${TELEGRAPH_URL}/?${qsParams}`, '_blank');

    return true;
  }

  redirectToSynxis({
    hotelCode,
    hotelBrand,
    startDate,
    endDate,
    numGuests,
    dateFormat,
  }) {
    const { BookingWidget } = window;

    if (!BookingWidget) {
      return false;
    }

    const {
      DEFAULT_DATE_FORMAT,
      SYNXIS_CONSTANTS: {
        SYNXIS_URL,
        SYNXIS_DATE_DEFAULT_JS_FORMAT,
        SYNXIS_BRAND_CODES,
      },
    } = BookingWidget.constants;

    const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
      const location = BookingWidget['allBrandsLocations'][key];
      return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
    });

    if (!hotelKey) {
      return false;
    }

    const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
    const synxisSettings = hotelData['synxisSettings'];
    const brand = hotelData['brand'];
    const ratesApiSource = hotelData['ratesApiSource'];

    if (!synxisSettings) {
      return false;
    }

    const synxisBrandCode = SYNXIS_BRAND_CODES[brand];

    if (!synxisBrandCode) {
      return false;
    }

    if (ratesApiSource !== 'ireckonu_api') {
      return false;
    }

    if (
      !synxisSettings.enableSynxisHotel
      || !synxisSettings.synxisChainId
    ) {
      return false;
    }

    const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

    const arriveMoment = moment(startDate, bookingDateFormat);
    let arrive = startDate;

    if (arriveMoment.isValid()) {
      arrive = arriveMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
    }

    const departMoment = moment(endDate, bookingDateFormat);
    let depart = endDate;

    if (departMoment.isValid()) {
      depart = departMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
    }

    const adultsCounts = [];
    const childrenCounts = [];

    numGuests.forEach((guest) => {
      const {
        numAdults,
        numChildren,
      } = guest;

      adultsCounts.push(isNaN(numAdults)? 0 : numAdults);
      childrenCounts.push(isNaN(numChildren)? 0 : numChildren);
    });

    const adult = adultsCounts.join(',');
    const child = childrenCounts.join(',');

    const rooms = numGuests.length;

    const params = {
      Hotel: synxisSettings.synxisHotelId,
      Chain: synxisSettings.synxisChainId,
      theme: synxisBrandCode,
      config: synxisBrandCode,
      arrive,
      depart,
      rooms,
      adult,
      child,
    };

    const qsParams = Object.keys(params).map((key) => {
      const value = params[key];

      if (!value) {
        return null;
      }

      return `${key}=${value}`;
    }).filter((param) => !!param).join('&');

    window.open(`${SYNXIS_URL}/?${qsParams}`, '_blank');

    return true;
  }

  onPlaceInputClickFocus(e) {
    e.preventDefault();

    const {
      loading,
      place,
    } = this.state;

    if (!loading && place.length > 0) {
      this.setState({showSuggestions: true});
    }
  }

  onPlaceInputBlur() {
    const OS = navigator.userAgent;

    // match if OS has Windows
    // bug fix for Windows browsers for not updating locaton input
    const delay = OS.match(/Windows/i) ? 500 : 200;

    // Add delay to fire click events before hiding
    setTimeout(() => {
      this.setState({showSuggestions: false});
    }, delay);
  }

  onPlaceInputChange(e) {
    const value = e.target.value;

    this.setState({place: value});
  }

  onPlaceInputKeyUp() {
    const {
      typingTimeout,
      loading,
      place,
    } = this.state;

    if (place.length == 0) {
      this.setState(this.initialState);
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    } else {
      if (typingTimeout || loading) {
        if (loading) {
          this.setState({
            typingTimeout: 0,
            loading: false,
            placeValid: false,
            selectedPlace: {},
            allPlaces: [],
            showSuggestions: false,
          });
          this.source.cancel('Cancelled retrieving data');
          this.source = axios.CancelToken.source(); // Generate new source token
        }

        clearTimeout(typingTimeout);
      }

      this.setState({
        typingTimeout: setTimeout(() => {
          this.loadPlaceSuggestions();
        }, 500),
      });
    }
  }

  loadPlaceSuggestions() {
    const {
      loading,
      place,
    } = this.state;

    // Stop loading old results
    if (loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    this.setState({
      loading: true,
      placeValid: false,
      selectedPlace: {},
      allPlaces: [],
      showSuggestions: false,
    });

    const data = {
      'action': constants.ACTION_GET_ACCOMMODATION_PLACES,
      'query': place,
    };

    // Send request
    axios.post(window.Ode['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const places = [...response.data['places']];

          this.setState({
            loading: false,
            selectedPlace: {},
            allPlaces: places,
            showSuggestions: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  onPlaceItemClick(e, placeItem) {
    e.preventDefault();

    this.setState({
      place: placeItem['name'],
      placeValid: true,
      selectedPlace: placeItem,
      allPlaces: [],
      showSuggestions: false,
    });

    $(document).trigger(constants.EVENT_BOOKING_SEARCH_PLACE_CHANGED, [placeItem['name']]);
    this.handleUrlParamsOnInput(placeItem['name']);
  }

  handleClearPlaceInput(e) {
    e.preventDefault();

    this.setState({
      typingTimeout: 0,
      loading: false,
      place: '',
      placeValid: true,
      selectedPlace: {},
      allPlaces: [],
      showSuggestions: false,
    });

    $(document).trigger(constants.EVENT_BOOKING_SEARCH_PLACE_CHANGED, ['']);
    this.handleUrlParamsOnInput();
  }

  handleUrlParamsOnInput(location = '') {
    const { autoSubmit } = this.props;

    if (autoSubmit == '1') {
      const params = helpers.getParameters();

      if (location.length > 0) {
        params['location'] = location;
      } else {
        delete params['location'];
      }

      helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');
    }

    return;
  }

  handleDateRangePickerChanged() {
    const { index } = this.props;
    const dateRangePicker = $('#accommodation-form-date-range-picker-' + index);
    if (dateRangePicker.length) {
      const form = dateRangePicker.closest('form.search-accommodations-form');
      const startDate = form.find('[name="startDate"]').val();
      const endDate = form.find('[name="endDate"]').val();

      if (startDate !== '' && endDate !== '') {
        this.setState({showDatesSeperator: true});
      } else {
        this.setState({showDatesSeperator: false});
      }
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const {
      autoSubmit,
      submitUrlBase,
    } = this.props;
    const {
      place,
      placeValid,
      selectedPlace,
    } = this.state;
    const form = $(e.target);

    const brand = selectedPlace && selectedPlace.brand ? selectedPlace.brand : window.Ode.brand;

    const hotelKey = `${place}|${brand}`;

    if (placeValid) {
      const startDateVal = form.find('[name="startDate"]').val();
      const endDateVal = form.find('[name="endDate"]').val();
      let startDate = '';
      let endDate = '';
      let submitUrl = '';

      if (startDateVal !== '' && endDateVal !== '') {
        startDate = moment(new Date(startDateVal)).format(constants.DATE_FORMAT_AUS);
        endDate = moment(new Date(endDateVal)).format(constants.DATE_FORMAT_AUS);
      }

      const numGuests = [{
        numAdults: 2,
        numChildren: 0,
      }];

      let location = window.BookingWidget['allBrandsLocations'][hotelKey];

      if (location && startDate && endDate) {
        const hotelCode = location['hotelCode'];
        const hotelBrand = location['brand'];
        const startDate = startDateVal;
        const endDate = endDateVal;

        if (this.redirectToSynxis({
          hotelCode,
          hotelBrand,
          startDate,
          endDate,
          numGuests,
        })) {
          return;
        }

        if (this.redirectToTelegraph({
          hotelCode,
          hotelBrand,
          startDate,
          endDate,
          numGuests,
        })) {
          return;
        }
      }

      if ('undefined' !== typeof window.Ode['mappedHotels'][hotelKey]) {
        location = window.Ode['mappedHotels'][hotelKey];

        if (startDate !== '' && endDate !== '' && location['hotel_code'].length > 0) {
          const params = {
            hotelCode: location['hotel_code'],
            startDate: startDate,
            endDate: endDate,
            numRooms: 1,
            numGuests,
          };

          if ('booking_target' in location) {
            params.channelCode = location['booking_target']['channel_code'];
          } else {
            params.channelCode = window.Ode['defaultChannelCode'];
          }

          if ('booking_target' in location && (location['booking_target']['domain'] !== 'independentcollection.com.au')) {
            submitUrl = location['booking_target']['rates_page'] + '?' + $.param(params);
          } else {
            helpers.docCookies.setItem('rsd_ba_b', JSON.stringify(params), 3600, '/', 'independentcollection.com.au');
            submitUrl = window.Ode['ratesPageUrl'];
          }
        } else {
          submitUrl = location['url'].replace(/\/?$/, '/');
        }
      } else if (autoSubmit == '' && submitUrlBase.length > 0) {
        submitUrl = submitUrlBase + '?location=' + encodeURIComponent(place);
      }

      if (startDate === '' && endDate === '') {
        helpers.docCookies.setItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE, '', 1500, '/', 'independentcollection.com.au');
        helpers.docCookies.setItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE, '', 1500, '/', 'independentcollection.com.au');
      }

      if (submitUrl.length > 0) {
        window.location = submitUrl;
      } else if (autoSubmit == '1') {
        $(document).trigger(constants.EVENT_SUBMIT_CLICKED_SEARCH, [place, startDate, endDate]);
      }
    }
  }

  handleFacilitiesChanged(e) {
    const value = e.target.value;
    const { facilities } = this.state;
    let selectedFacilities = [...facilities];

    if (event.target.checked) {
      selectedFacilities.push(value);
    } else {
      selectedFacilities = selectedFacilities.filter((facility) => {
        return facility != value;
      });
    }

    this.setState({facilities: selectedFacilities});

    const selectedFacilitiesString = selectedFacilities.join();
    const params = helpers.getParameters();

    if (selectedFacilitiesString.length > 0) {
      params['facilities'] = selectedFacilitiesString;
    } else {
      delete params['facilities'];
    }

    helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

    $(document).trigger(constants.EVENT_FACILITES_FILTER_CHANGED_SEARCH, [selectedFacilitiesString]);
  }

  render() {
    const {
      index,
      autoSubmit,
      showFilters,
    } = this.props;
    const {
      loading,
      place,
      placeValid,
      selectedPlace,
      allPlaces,
      showSuggestions,
      showDatesSeperator,
      facilities,
    } = this.state;

    return (
      <Fragment>
        <form action="#" className="relative search-accommodations-form" onSubmit={this.handleSubmit}>
          <div className="flex flex-wrap lg:flex-no-wrap justify-between relative items-stretch">
            <div className="inner-content">
              <div className="input-group">
                <label className="mb-0 block relative">
                  <div className="label-wrapper">Where</div>
                  <div className="input-wrapper location-wrapper">
                    <input className="where place-search"
                           value={place}
                           type="text"
                           name="place"
                           autoComplete="off"
                           onClick={this.onPlaceInputClickFocus}
                           onFocus={this.onPlaceInputClickFocus}
                           onBlur={this.onPlaceInputBlur}
                           onChange={this.onPlaceInputChange}
                           onKeyUp={this.onPlaceInputKeyUp}
                           placeholder="Location, hotel name"
                    />
                    {
                      place.length > 0 && (
                        <Fragment>
                          {
                            showSuggestions && (
                              <div className="place-suggestions-wrapper">
                                {
                                  Object.keys(selectedPlace).length > 0 && selectedPlace.constructor === Object
                                    ? (
                                      <div className="place-category-wrapper">
                                        <div className="place-item"
                                             {...selectedPlace['attribs']}
                                        >
                                          <img src={selectedPlace['icon']} className="icon mr-2" />
                                          <span className="name">{selectedPlace['name']}</span>
                                        </div>
                                      </div>
                                    ) : (
                                      <Fragment>
                                        {
                                          allPlaces.length > 0
                                            ? (
                                              <Fragment>
                                                {
                                                  allPlaces.map((placeCat, i) => {
                                                    return (
                                                      <Fragment key={i}>
                                                        {
                                                          placeCat['places'].length > 0 && (
                                                            <div className="place-category-wrapper">
                                                              {
                                                                placeCat['title'].length > 0 && (
                                                                  <div className="place-category-title">
                                                                    {placeCat['title']}
                                                                  </div>
                                                                )
                                                              }
                                                              {
                                                                placeCat['places'].map((placeItem, j) => {
                                                                  return (
                                                                    <div key={j}
                                                                         className="place-item"
                                                                         {...placeItem['attribs']}
                                                                         onClick={(e) => this.onPlaceItemClick(e, placeItem)}
                                                                    >
                                                                      <img src={placeItem['icon']} className="icon mr-2" />
                                                                      <span className="name">{placeItem['name']}</span>
                                                                    </div>
                                                                  );
                                                                })
                                                              }
                                                            </div>
                                                          )
                                                        }
                                                      </Fragment>
                                                    );
                                                  })
                                                }
                                              </Fragment>
                                            ) : (
                                              <div className="no-results-found">No results found</div>
                                            )
                                        }
                                      </Fragment>
                                    )
                                }
                              </div>
                            )
                          }
                          {
                            ! loading
                              ? (
                                <Fragment>
                                  {
                                    allPlaces.length > 0 && (
                                      <div className="" />
                                    )
                                  }
                                  <div className="clear-button" onClick={this.handleClearPlaceInput}>
                                    <div className="flex items-center">
                                      <img src={window.Ode['assetsPath'] + 'images/icons/times.svg'} />
                                    </div>
                                  </div>
                                </Fragment>
                              ) : (
                                <div className="loading-icon">
                                  <div className="spinner-loader small" />
                                </div>
                              )
                          }
                        </Fragment>
                      )
                    }
                  </div>
                </label>
              </div>
              <div className="input-group">
                <label className="relative mb-0 block pr-0 lg:pr-6">
                  <div className="label-wrapper">When</div>
                  <div className="input-wrapper calendar-wrapper">
                    <input id={'accommodation-form-date-range-picker-' + index}
                           className={'booking-daterange-picker ' + (!showDatesSeperator ? 'hidden-end-date' : '')}
                           type="text"
                           autoComplete="off"
                           defaultValue=""
                           readOnly
                           data-cookie-start-date={constants.COOKIE_KEY_ACCOMMODATION_SEARCH_START_DATE}
                           data-cookie-end-date={constants.COOKIE_KEY_ACCOMMODATION_SEARCH_END_DATE}
                           data-cookie-populate={autoSubmit == '1' ? 'on' : 'off'}
                    />
                    <div className="when input-dates-wrapper">
                      <input className="w-full check-in"
                             type="text"
                             readOnly
                             name="checkin"
                             placeholder="I'm Flexible"
                      />
                      <input type="hidden" name="startDate" />
                      {
                        showDatesSeperator && (
                          <span className="px-4 input-date-separator">-</span>
                        )
                      }
                      <input className="w-full check-out"
                             type="text"
                             readOnly
                             name="checkout"
                             placeholder=""
                      />
                      <input type="hidden" name="endDate" />
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <button type="submit" className="btn btn-secondary submit-button" disabled={loading || !placeValid}>
              <span>Check</span>
              <span className="inline-block lg:hidden">{'\u00A0'}Hotels</span>
              <span className="hidden lg:inline-block">{'\u00A0'}Availability</span>
            </button>
          </div>
        </form>
        {
          (showFilters == '1') && (
            <div className="form-filters mt-4 flex flex-col lg:flex-row items-center">
              {
                this.facilities.length > 0 && (
                  <div className="facilities-filter search-form-filter-dropdown dropdown mr-0 lg:mr-6 mb-6 lg:mb-0">
                    <button className={'btn btn-filter dropdown-toggle px-4 py-2 w-full ' + (facilities.length > 0 ? 'active' : '')} type="button" id="facilities-dropdown-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Facilities
                    </button>
                    <div className="dropdown-menu" aria-labelledby="facilities-dropdown-menu">
                      <div className="flex flex-wrap -mx-4">
                        {
                          helpers.divideArray(this.facilities, Math.ceil(this.facilities.length / 2)).map((hotelFacilitiesCol, i) => {
                            return (
                              <div key={i} className="w-full lg:w-1/2 px-4">
                                {
                                  hotelFacilitiesCol.map((facility, j) => {
                                    return (
                                      <div key={j} className="custom-checkbox mb-4">
                                        <input id={facility[0]}
                                               type="checkbox"
                                               name="facility"
                                               value={facility[0]}
                                               onChange={this.handleFacilitiesChanged}
                                               checked={facilities.indexOf(facility[0]) > -1}
                                        />
                                        <label htmlFor={facility[0]}>
                                          {facility[1]}
                                        </label>
                                      </div>
                                    );
                                  })
                                }
                              </div>
                            );
                          })
                        }
                      </div>
                    </div>
                  </div>
                )
              }
            </div>
          )
        }
      </Fragment>
    );
  }
}

AppSearchAccommodations.propTypes = {
  index: PropTypes.number.isRequired,
  autoSubmit: PropTypes.string,
  showFilters: PropTypes.string,
  submitUrlBase: PropTypes.string,
};

AppSearchAccommodations.defaultProps = {
  autoSubmit: '',
  showFilters: '',
  submitUrlBase: '',
};


const searchAccommodations = () => {
  jQuery(document).ready(function($) {
    const accommodationsFormWrapper = $('.search-accommodations-form-wrapper');
    if (accommodationsFormWrapper.length) {
      for (let i = 0; i < accommodationsFormWrapper.length; i++) {
        const formProps = {...accommodationsFormWrapper[i].dataset};

        ReactDOM.render(<AppSearchAccommodations index={i} {...formProps} />, accommodationsFormWrapper[i]);
      }

      $(document).on('click', '.form-filters .search-form-filter-dropdown .dropdown-menu *', function (e) {
        e.stopPropagation();
      });
    }
  });
};

export default searchAccommodations;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchAccommodations.js